import SubLabel from "components/Atoms/Sublabel";
import { Dot } from "components/Dot";
import { VisibilityDotLabel } from "components/Dot/DotLabel";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { getCurrency } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { findCountryById } from "utilities/countrystateutils";
import VisibilityFilter from "components/filters/Filters/VisibilityFilter";
import CompanyFilter from "components/filters/Filters/CompanyFilter";
import { useLoaderData } from "react-router";
import { BookkeepingSidePanel } from "components/SidePanel/Bookkeeping/BookkeepingSidePanel";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";

const BookkeepingListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BookkeepingListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="bookkeeping_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={{ ...viewModel.initialInstruction, clientId: site.currentEnvironment.client.clientId }}
        fetchFunction={window.CoreApi.Bookkeeping.Paginated}
        getId={item => item.bookkeepingId}
        onNew={() => window.location.href = routes.bookkeeping_New().absolute}
        layout={{
          type: "table",
          columns: [
            {
              key: "title",
              header: RESX.GeneralLabels.Title,
              render: item => <div>
                <BookkeepingSidePanel bookkeepingId={item.bookkeepingId} trigger={<a>{item.name}</a>} />
                <div>
                  <VisibilityDotLabel visible={item.visible} />
                </div>
              </div>
            }, {
              key: "code",
              header: RESX.Bookkeeping.Code,
              render: item => item.code
            }, {
              key: "company",
              header: RESX.Company.resxCompany,
              render: item => <CompanySidePanel companyId={item.company.companyId} trigger={<a>{item.company.name}</a>} />
            }, {
              key: "resetsOnNewYear",
              header: RESX.Bookkeeping.ResetOnNewYear,
              render: item => item.resetOnNewYear ? <Dot color={serverReference.constants.colors.green} /> : <Dot color={serverReference.constants.colors.red} />
            }, {
              key: "startingNumber",
              header: RESX.Bookkeeping.StartingNumber,
              render: item => item.offsetText
            }, {
              key: "locatedIn",
              header: RESX.Address.LocatedIn,
              render: item => {
                const country = findCountryById(item.companyAdmCountry);

                return <div>
                  <div>{country.code}</div>
                  {country.isEuMember && <SubLabel small>{RESX.VatNumber.InEU}</SubLabel>}
                </div>
              }
            }, {
              key: "currency",
              header: RESX.Financial.Currency,
              render: item => getCurrency(item.baseCurrency).text
            }
          ]
        }}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
          <CompanyFilter
            title={RESX.Company.resxCompany}
          />
          <VisibilityFilter />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
};


export default BookkeepingListApp;